import { z } from 'zod'
import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '../../common'

// ======================== Listing ========================

export const RoleSearchParamsSchema = z
  .object({
    q: z.string().optional(),
  })
  .merge(BasePaginateParamsSchema)

export type RoleSearchParams = z.infer<typeof RoleSearchParamsSchema>

export const RoleSearchResultModelSchema = z.object({
  id: z.number(),
  name: z.string(),
})

export type RoleSearchResultModel = z.infer<typeof RoleSearchResultModelSchema>

export const RoleSearchResultSchema = z
  .object({
    data: z.array(RoleSearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type RoleSearchResult = z.infer<typeof RoleSearchResultSchema>
